import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

type Props = {
  onBack: () => void;
  title: string;
};

export const RenderingsMobileHeader = ({ onBack, title }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="grid shrink-0 grid-cols-3 items-center border-b border-slate-200 px-2 py-1">
      <div className="flex justify-start">
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              type="button"
              className="rounded-full border-transparent p-2 hover:border-transparent hover:bg-primary-light/10 [&_svg]:text-primary-light hover:[&_svg]:text-primary"
              onClick={onBack}
              aria-label={t('back')}
            >
              <ArrowLeft />
            </Button>
          </TooltipTrigger>
          <TooltipContent className="border bg-white text-black shadow">{t('back')}</TooltipContent>
        </Tooltip>
      </div>

      <h1 className="min-w-0 truncate text-center text-base font-semibold text-text-primary">
        {title}
      </h1>

      <div className="flex justify-end" aria-hidden>
        <div className="rounded-full p-2">
          <ArrowLeft className="invisible" />
        </div>
      </div>
    </div>
  );
};
